// extracted by mini-css-extract-plugin
export default {"card":"NFTAssetGroup_card__cS7fb","main":"NFTAssetGroup_main__DwMmI","icon":"NFTAssetGroup_icon__TQVnz","link":"NFTAssetGroup_link__LsKjQ"};